import type { WipSortFieldE, WipSortOrderE } from 'declarations/enums/wip';
import type {
  DealerCardResponseI,
  OemFamilyClaimStatusesI,
  WipAgentI,
  WipListFiltersI,
  WipRecordListI,
} from 'declarations/interfaces/wip';

import { get, post, put } from './api';

export interface GetWipRecordsRequestI {
  paging?: {
    currentPage?: number;
    countPerPage?: number;
  };
  sorting?: {
    parameter?: WipSortFieldE;
    order?: WipSortOrderE;
  };
  filter?: WipListFiltersI;
}

export const WIP_API_BASE = '/wip';

export const getWipRecordsApi = async (request: GetWipRecordsRequestI): Promise<WipRecordListI> => {
  const response = await post<WipRecordListI>(`${WIP_API_BASE}/records/list`, request);
  return response.data;
};

export const getWipDealerSummaryApi = async (): Promise<DealerCardResponseI> => {
  const response = await get<DealerCardResponseI>(`${WIP_API_BASE}/dealer-summary`);
  return response.data;
};

export const getWipAgentsApi = async (): Promise<WipAgentI[]> => {
  const response = await get<WipAgentI[]>(`${WIP_API_BASE}/agents`);
  return response.data;
};

export const getWipOemFamilyClaimStatusesApi = async (): Promise<OemFamilyClaimStatusesI[]> => {
  const response = await get<OemFamilyClaimStatusesI[]>(
    `${WIP_API_BASE}/oem-family-claim-statuses`
  );
  return response.data;
};

export interface UpdateWipRecordRequestI {
  wipId: string;
  rowVersion: string;
  repairOrderNumber: string;
  roofTopId: string;
  openRepairOrderDate: string;
  lineNumber: string;
  advisorNumber: string;
  techNumber: string;
  wipStatus: string;
  oemClaimStatus: string;
  assigneeId?: string | null;
  priority: string;
  backlog: boolean;
  isSublet: boolean;
  repairOrderTotal?: number | null;
  partsAmountClaimed?: number | null;
  partsAmountPaid?: number | null;
  laborAmountClaimed?: number | null;
  laborAmountPaid?: number | null;
  techTime?: number | null;
  oemPaidTotal?: number | null;
  claimTotal?: number | null;
  oemPaidDate?: string | null;
  submittedDate?: string | null;
  repairOrderStatusEnum?: string | null;
  notes?: string | null;
}

export const updateWipRecordApi = async (request: UpdateWipRecordRequestI): Promise<void> => {
  await put<void>(`${WIP_API_BASE}/records/${request.wipId}`, request);
};

export interface AddWipRecordRequestI {
  repairOrderNumber: string;
  roofTopId: string;
  openRepairOrderDate: string;
  lineNumber: string;
  advisorNumber: string;
  techNumber: string;
  oemClaimStatus: string;
  assigneeId?: string | null;
  priority: string;
  backlog: boolean;
  isSublet: boolean;
  repairOrderTotal?: number | null;
  partsAmountClaimed?: number | null;
  partsAmountPaid?: number | null;
  laborAmountClaimed?: number | null;
  laborAmountPaid?: number | null;
  techTime?: number | null;
  oemPaidTotal?: number | null;
  oemPaidDate?: string | null;
  submittedDate?: string | null;
  repairOrderStatusEnum?: string | null;
  notes?: string | null;
}

export const addWipRecordApi = async (request: AddWipRecordRequestI): Promise<void> => {
  await post<void>(`${WIP_API_BASE}/records`, request);
};
